import { UserAPI } from "../api";
import moment from 'moment'

export class User {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  
  static async getUserOTP(payload) {
    const { data } = await UserAPI.getUserOTP(payload);
    return data.result
    // return new User(data.result)
  }
  static async loginUserOTP(payload) {
    const { data } = await UserAPI.loginUserOTP(payload);
    return new User(data.result)
  }

}

function dayMonthYearText(packageEndDate) {

}
